import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';

const Terms: React.FC = () => (
  <Box>
    <Typography mb={1}>
      By continuing, you are accepting Credit Pulse&apos;s
      {' '}
      <a
        href='https://www.creditpulse.com/esignature-terms-and-conditions'
        rel='noopener noreferrer'
        target='_blank'
      >
        Terms and Conditions.
      </a>
    </Typography>
  </Box>
);

export default Terms;
